import { render } from "./GeneralSettingPage.vue?vue&type=template&id=4dc53f88&ts=true"
import script from "./GeneralSettingPage.vue?vue&type=script&lang=ts"
export * from "./GeneralSettingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__